import clsx from 'clsx';
import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import CopyLinkButton from '@components/pages/Organization/AccountSection/RegistrationLinks/CopyLinkButton';
import { Theme } from '@interfaces/global';
import { MIN_COMMENTS_COUNT } from '@interfaces/homepage';
import { article_path, newsletter_article_path } from '@routes';
import { articlePath } from '@utils/queryStringHelper';

import { Author } from '../../interfaces/authors';
import CommentsCount from '../FeedItems/CommentsCount';
import NameList from '../NameList';
import TimeAgo from '../TimeAgo';

interface BylineProps {
  authors?: Author[];
  authorsClassName?: string;
  className?: string;
  commentsCount?: number;
  isRelatedArticle?: boolean;
  linkToCopy?: string;
  publishedAt?: string;
  newsletterSlug?: string;
  slug?: string;
  timeFromNow?: boolean;
  withTooltip?: boolean;
  theme?: Theme;
}

const Byline = ({
  authors,
  authorsClassName,
  className,
  commentsCount = 0,
  isRelatedArticle = false,
  linkToCopy,
  publishedAt,
  newsletterSlug,
  slug,
  timeFromNow,
  withTooltip = false,
  theme = Theme.Light,
}: BylineProps) => {
  return (
    <QueryClientProvider client={new QueryClient()}>
      <div
        className={clsx('font-suisse-screen', className, {
          'text-byline-sm': !isRelatedArticle,
          'text-disclosure-sm': isRelatedArticle,
          'flex flex-wrap items-center': commentsCount >= MIN_COMMENTS_COUNT,
          'flex justify-between': linkToCopy,
          'text-black': theme === Theme.Light,
          'text-white': theme === Theme.Dark,
        })}
      >
        {authors?.length > 0 && !linkToCopy && (
          <div className="mr-10 inline-block">
            <NameList
              authors={authors}
              authorClassName={authorsClassName}
              theme={theme}
              withTooltip={withTooltip}
            />
          </div>
        )}
        {publishedAt && (
          <TimeAgo
            className={clsx('inline-block text-grayscale-gray', {
              'text-grayscale-gray': theme === Theme.Light,
              'text-grayscale-beige': theme === Theme.Dark,
              'mr-10': commentsCount >= MIN_COMMENTS_COUNT,
            })}
            date={publishedAt}
            timeFromNow={timeFromNow}
          />
        )}
        {linkToCopy && (
          <CopyLinkButton
            className="text-grayscale-gray"
            label="Copy link"
            linkToCopy={linkToCopy}
          />
        )}
        {commentsCount >= MIN_COMMENTS_COUNT && !linkToCopy && (
          <CommentsCount
            numberOfComment={commentsCount}
            url={articlePath({ slug, newsletterSlug })}
          />
        )}
      </div>
    </QueryClientProvider>
  );
};

export default Byline;
